import { useMutation } from "react-query";

import { useApi } from "../../providers/ApiProvider";
import { APQueryOptions, useAPQuery } from "../../providers/APQueryProvider";

type PatchFinanceComparisonViewPayload = {
  financeComparisonViewId: string;
  clickedCriteria: string;
};

export const patchQuoteFinanceComparisonView = (
  quoteId: string,
  options: APQueryOptions = {}
) => {
  const { fetchWithAuth } = useApi();
  const { defaultOnMutateError, defaultOnMutateSuccess } = useAPQuery();

  return useMutation({
    mutationFn: (
      payload: PatchFinanceComparisonViewPayload
    ): Promise<string> => {
      return fetchWithAuth<string>("patchQuoteFinanceComparisonView", quoteId, {
        requestOptions: {
          method: "PATCH",
          body: JSON.stringify(payload),
        },
      });
    },
    onError: defaultOnMutateError(options),
    onSuccess: defaultOnMutateSuccess(options),
  });
};
